var a = Object.defineProperty;
var d = (s, t, e) => t in s ? a(s, t, { enumerable: !0, configurable: !0, writable: !0, value: e }) : s[t] = e;
var o = (s, t, e) => d(s, typeof t != "symbol" ? t + "" : t, e);
import { Mark as h } from "prosemirror-model";
import { hasNativeEmojiSupport as c, substituteColonifiedForUnicode as m } from "./utils/emoji.js";
class u {
  constructor(t) {
    o(this, "schema");
    o(this, "stack");
    o(this, "marks");
    o(this, "docNode");
    this.schema = t, this.stack = [{ type: t.topNodeType, infoContent: [], content: [] }], this.marks = h.none;
  }
  get doc() {
    if (!this.docNode) {
      if (this.stack.length !== 1)
        throw new Error("Document has unclosed nodes");
      this.docNode = this.closeNode();
    }
    return this.docNode;
  }
  top() {
    return this.stack[this.stack.length - 1];
  }
  push(t) {
    this.stack.length && this.top().content.push(t);
  }
  openNode(t, e) {
    this.stack.push({ type: t, attrs: e, infoContent: [], content: [] });
  }
  closeNode() {
    let t = this.stack.pop();
    if (!t)
      throw new Error("Tried to close a non existent node");
    let e = t.type.createAndFill(t.attrs, t.content, this.marks);
    if (!e)
      throw new Error("Undefined node type");
    return this.push(e), e;
  }
  addText(t) {
    if (!t)
      return;
    c() || (t = m(t));
    let e = this.top().content, r = e[e.length - 1], i = this.schema.text(t, this.marks), n = r && this.maybeMerge(r, i);
    n ? e[e.length - 1] = n : e.push(i);
  }
  openMark(t) {
    this.marks = t.addToSet(this.marks);
  }
  closeMark(t) {
    this.marks = t.removeFromSet(this.marks);
  }
  maybeMerge(t, e) {
    if (t.isText && e.isText && h.sameSet(t.marks, e.marks))
      return t.withText(t.text + e.text);
  }
}
export {
  u as DocumentBuilder
};
